<template></template>
<script>
export default {
  data() {
    return {
      randList: [],
      randTimer: null,
      index: 0,
    };
  },
  props: {
    bigClass: {
      type: [String],
      default: null,
    },
    lotteryCode: {
      type: [String],
      default: null,
    },
    types: {
      type: [String],
      default: null,
    },
    drawingNumber: {
      type: [Array],
      default: [],
    },
  },
  watch: {
    drawingNumber: {
      handler(newName, oldName) {
        this.getList();
      },
      immediate: true,
    },
  },
  computed: {
    drawList() {
      const { drawingNumber, randList } = this;
      const drawList = drawingNumber.length > 1 ? drawingNumber : randList;
      return drawList;
    },
    _lotteryTypeCode() {
      if (this.bigClass) {
        return this.bigClass;
      }
      return this.$store.state.lottery.lotteryTypeCode;
    },
  },
  methods: {
    getList() {
      const { drawingNumber, _lotteryTypeCode, randLottery } = this;
      clearInterval(this.randTimer);
      if (drawingNumber.length <= 1) {
        // this.randList = this.$tools.randLottery(_lotteryTypeCode);
        // this.randTimer = setInterval(() => {
        //   this.randList = this.$tools.randLottery(_lotteryTypeCode);
        // }, 200);
        this.randList = randLottery(_lotteryTypeCode);
        this.randTimer = setInterval(() => {
          this.randList = randLottery(_lotteryTypeCode);
        }, 40);
      }
    },
    //随机一个开奖号码
    randLottery(lotteryType) {
      switch (lotteryType) {
        case "SSC":
          return this.order({ min: 0, max: 9, len: 5 });
        case "PCDD":
          return this.randomNum({ min: 0, max: 9, len: 3 });
        case "LHC":
          return this.order({ min: 1, max: 49, len: 7, zero: true });
        case "LSC":
          return this.order({ min: 1, max: 60, len: 7, zero: true });
        case "K3":
          return this.order({ min: 1, max: 6, len: 3 });
        case "3D":
          return this.order({ min: 0, max: 9, len: 3 });
        case "PL3":
          return this.order({ min: 0, max: 9, len: 3 });
        case "PK10":
          return this.randomNum({ min: 1, max: 10, len: 10, zero: true });
        case "11X5":
          return this.order({ min: 1, max: 11, len: 5, zero: true });
        case "DLT":
          return this.randomArray([
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35"
          ]).slice(0, 5).sort((a, b) => { Number(a) - Number(b) }).concat(this.randomArray([
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
          ]).slice(0, 2).sort((a, b) => Number(a) - Number(b)))
        case "SSQ":
          return this.randomArray([
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
            "32",
            "33",
          ]).slice(0, 6).sort((a, b) => Number(a) - Number(b)).concat(this.randomNum({ min: 1, max: 16, len: 1, zero: true }));
      }
    },
    //打乱数组
    randomArray(arr) {
      return [...arr].sort(function () {
        return 0.5 - Math.random();
      });
    },
    //随机开奖
    randomNum({ min, max, len, zero }) {
      let list = [];
      for (let i = 0; i < len; i++) {
        let numb = String(this.random(min, max));
        list.push(zero === true && numb.length == 1 ? `0${numb}` : numb);
      }
      return list;
    },
    //顺序开奖
    order({ min, max, len, zero }) {
      let list = [];
      let numb;
      if (this.index == 0 && min == 1) {
        this.index = 1
      }
      if (this.index > max) {
        this.index = min
      }
      for (let i = 0; i < len; i++) {
        numb = String(this.index)
        list.push(zero && numb.length == 1 ? `0${numb}` : numb);
      }
      this.index++
      return list;
    },
    //随机
    random(lower, upper) {
      return Math.floor(Math.random() * (upper - lower + 1)) + lower;
    },
  },
};
</script>